import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import DeliveryDiningOutlinedIcon from "@mui/icons-material/DeliveryDiningOutlined";
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined";
import { SendIcon } from "./ActionIcons";
import { DoneAllIcon, DoneIcon } from "./ResultIcons";
import RemoveDoneIcon from "@mui/icons-material/RemoveDone";
import { FaDraftingCompass } from "react-icons/fa";
import { useTheme } from "@mui/material";
import PropTypes from "prop-types";

export function Tila_luonnosIcon({ color = "success", ...props }) {
  const theme = useTheme();
  const iconColor = color == null ? "inherit" : theme.palette[color]?.main;
  return (
    <span style={{ color: iconColor }}>
      <FaDraftingCompass {...props} />
    </span>
  );
}
Tila_luonnosIcon.propTypes = {
  color: PropTypes.string,
};

export function Tila_lähetettyIcon(props) {
  return <SendIcon {...props} />;
}
export function Tila_käsittelyssäIcon(props) {
  return <ConstructionOutlinedIcon {...props} />;
}
export function Tila_peruttuIcon(props) {
  return <CancelOutlinedIcon {...props} />;
}
export function Tila_toimitusValmisIcon(props) {
  return <DeliveryDiningOutlinedIcon {...props} />;
}
export function Tila_meneilläänIcon(props) {
  return <HourglassTopOutlinedIcon {...props} />;
}
export function Tila_toimitettu1Icon(props) {
  return <DoneIcon {...props} />;
}
export function Tila_toimitettu2Icon(props) {
  return <DoneIcon {...props} />;
}
export function Tila_toimitettu3Icon(props) {
  return <DoneIcon {...props} />;
}
export function Tila_valmisIcon(props) {
  return <DoneAllIcon {...props} />;
}
export function Tila_epäonnistuiIcon(props) {
  return <CancelOutlinedIcon {...props} />;
}
export function Tila_poistettuIcon(props) {
  return <CancelOutlinedIcon {...props} />;
}
export function Tila_muuIcon(props) {
  return <RemoveDoneIcon {...props} />;
}
